module.exports = __webpack_public_path__ + "3e374cd51b995fbc697fdda36a176115.MP3";